const introInfo = {
    name: 'Fabian Walocha',
    title: 'Research Fellow',
    location: 'Braunschweig, Germany',
    description: 'Welcome to my page!',
    image: 'ec.jpg',
}

//dynamic icon
const socialMediaInfo = [{
        name: 'linkedin',
        link: 'https://www.linkedin.com/in/fabian-walocha-790359144/',
        username: 'fabian-walocha',
        displayName: 'linkedin/fabian-walocha'
    },

    {
        name: 'github',
        link: 'https://github.com/FabianWalocha',
        username: 'FabianWalocha',
        displayName: 'github/FabianWalocha'
    },
    // {
    //     name: 'stack-overflow',
    //     link: 'http://localhost:8080',
    //     username: 'coskuncayemre',
    //     displayName:'stackoverflow.com'
    // },
    // {
    //     name: 'stack-overflow',
    //     link: 'http://localhost:8080',
    //     username: 'coskuncayemre',
    //     displayName:'stackoverflow.com'
    // },
]

const contactInfo = [
    {
        name: 'envelope',
        context: 'fabian@walocha.me',
        size: '20px',
        style: "font-size:20px;margin-right: 10px;",
        link: 'mailto:fabian@walocha.me'
    },
    {
        name: 'globe',
        context: 'Google Scholar',
        size: '20px',
        style: "font-size:20px;margin-right: 13px;",
        link: 'https://scholar.google.com/citations?view_op=list_works&hl=en&user=ewFCvJ4AAAAJ'
    },
    
    // {
    //     name: 'phone-square',
    //     context: '+49 531 338138',
    //     size: '23px',
    //     style: "font-size:23px;margin-right: 10px;",
    //     link: 'tel:+49 531 338138'
    // },
]

const summaryInfo = 
    "Hi there! My name is Fabian Walocha, I'm a research fellow and doctoral candidate in computer science at DLR Germany. My research is on smart mobility services with applications for road, rail and intermodal traffic systems. I am particularly interested in applications of user modeling to solve human factors challenges for human-technology interaction."


const publicationInfo = [
    {"authors" : "Walocha, F., Drewitz, U., & Ihme, K.", 
     "year" : 2022,
     "title" : "Activity and stress estimation based on OpenPose and electrocardiogram for user-focused level-4-vehicles.",
     "meta" : "IEEE Transactions on Human-Machine Systems, 52(4), 538-546."
    },
    {"authors": "Schrank, A. G., Walocha, F., Wendorff, N., Nguyen, H. P., Rudolph, F., & Oehl, M.",
     "year": 2023,
     "title": "Remote Operation as a Key Enabler for Autonomous Driving: User-Centred Design and Expert Evaluation of a Prototypical Workplace for the Technical Supervisor.",
     "meta" : "Abstracts of the Annual Meeting 2023 of the Human Factors and Ergonomics Society (HFES)-Europe Chapter"
    },
    {"authors" : "Schrank, A., Walocha, F., Brandenburg, S., & Oehl, M.",
     "year" : 2024, 
     "title": "Human-centered design and evaluation of a workplace for the remote assistance of highly automated vehicles." ,
     "meta" : "Cognition, Technology & Work, 26(2), 183-206."},

    {"authors": "Walocha, F., Schrank, A., Nguyen, H. P., & Ihme, K.",
     "year" : 2025,
     "title" : "Multimodal assessment of mental workload during automated vehicle remote assistance: Modeling of eye-tracking-related, skin conductance, and cardiovascular indicators.",
     "meta" : "Information, 16(1), 64."
    },
    {"authors": "Walocha, F., Valerio, A., Nguyen, P., & Ihme, K.",
     "year" : 2025,
     "title" : "Understanding Effects and Physiological Correlates of Operator Workload Across Remote Assistance Scenarios for Automated Vehicles-Results from a User Study.",
     "meta" : "International Conference on Human-Computer Interaction (pp. 102-111). Cham: Springer Nature Switzerland."
    },
]

//desc v-html 
const experinceInfo = [
    {
        workAt: 'DLR Germany',
        position: 'Research Fellow',
        duration: 'Sep 2020 – ongoing',
        description: 'Research & development of user-adaptive systems with applications in user modeling, wearable integration & AI assistance.',
        techs: ["Python", "Kotlin", "Imotions", "PsychoPy", "Qt"]
    },
    {
        workAt: 'Télécom Paris (Intern)',
        position: 'Research Assistant',
        duration: 'Mar 2020 - Aug 2020',
        description: 'Modeling taks and social group cohesion, research on multi modal behavioral data, social signal processing.',
        techs: ["Python"]
    },
    {
        workAt: 'DLR Germany (Intern)',
        position: 'Research Assistant',
        duration: 'Aug 2019 - Jan 2020',
        description: 'Modeling driver activity and task related stress during non-driving related tasks.',
        techs: ["Python",  "R", "SQLite"]
    },
    {
        workAt: 'Universität Kassel',
        position: 'Research Assistant',
        duration: 'Apr 2018 - Sep 2018',
        description: 'Probabilistic forecasting for wind and solar facilities',
        techs: ["Python"]
    },
    {
        workAt: 'Donders Institute for Brain, Cognition and Behaviour (Intern)',
        position: 'Research Assistant',
        duration: 'Jan 2018 – Aug 2018',
        description: 'Modeling functional connectomes in fMRI',
        techs: ["Matlab"]
    }
]

const educationInfo = [
    {
        school: 'Université Jean Monnet',
        location: 'Saint-Étienne, France',
        title: 'MSc in Machine Learning and Data Mining',
        duration: '2018 - 2020',
        description: '<b>GPA:</b> 16.5/20.0',
    },
    {
        school: 'Universität Osnabrück',
        location: 'Osnabrück, Germany',
        title: 'BSc in Cognitive Science',
        duration: '2013 – 2017',
        description: '<b>GPA:</b> 1.6',
    },
]

const volunteerInfo = [
    // {
    //     organisation: 'The English Studio Language School',
    //     title: 'Student',
    //     duration: 'July 2018 - Sep 2018',
    //     description: 'London,UK',
    // },
    // {
    //     organisation: 'Hacettepe University,Social Life Organization',
    //     title: 'Organization Manager',
    //     duration: '2015 – 2021',
    //     description: '',
    // }, {
    //     organisation: 'Hacettepe University,Community of Contest',
    //     title: 'Organization Manager',
    //     duration: '2016 – 2018',
    //     description: '',
    // },
    // {
    //     organisation: 'Hacettepe University ACM',
    //     title: 'Member',
    //     duration: '2015 – 2020',
    //     description: '',
    // }
]

const certificateInfo = [
    // {
    //     organisation: 'Red Hat',
    //     title: 'Red Hat Certified System Administrator RH124',
    //     duration: 'Feb,2021',
    //     description: '',
    // },
    // {
    //     organisation: 'KOSGEB',
    //     title: 'Entrepreneurship Certificate',
    //     duration: 'Jun,2019',
    //     description: '',
    // },
]

const projectInfo = [{
    //     title: 'Project 1',
    //     meta: 'Propulsion Engineer',
    //     description: 'Responsibilities included: writing technical reports and other documentation, such as handbooks and bulletins, for use by engineering staff, management, and customers, analyzing project requests and proposals and engineering data to determine feasibility, predictability, cost, and production time of aerospace or aeronautical product.',
    //     images: [{
    //             thumbnail: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=firstimage&w=150&h=150',
    //             original: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=firstimage&w=900&h=900'
    //         },
    //         {
    //             thumbnail: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=secondimage&w=150&h=150',
    //             original: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=secondimage&w=900&h=900'
    //         },
    //         {
    //             thumbnail: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=thirdImage&w=150&h=150',
    //             original: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=thirdImage&w=900&h=900'
    //         }
    //     ]
    // },
    // {
    //     title: 'Project 1',
    //     meta: 'Propulsion Engineer',
    //     description: 'Responsibilities included: writing technical reports and other documentation, such as handbooks and bulletins, for use by engineering staff, management, and customers, analyzing project requests and proposals and engineering data to determine feasibility, predictability, cost, and production time of aerospace or aeronautical product.',
    //     images: [{
    //             thumbnail: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=firstimage&w=150&h=150',
    //             original: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=firstimage&w=900&h=900'
    //         },
    //         {
    //             thumbnail: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=secondimage&w=150&h=150',
    //             original: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=secondimage&w=900&h=900'
    //         },
    //         {
    //             thumbnail: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=thirdImage&w=150&h=150',
    //             original: 'http://placeholdit.imgix.net/~text?txtsize=33&txt=thirdImage&w=900&h=900'
    //         }
    //     ]
    }
]

const skillInfo = [
    {
        name: 'Python',
        rate: 85,
    },


    {
        name: 'Kotlin',
        rate: 70,
    },

    {
        name: 'R',
        rate: 55,
    },

    {
        name: 'Matlab',
        rate: 45,
    }, 


    {
        name: 'C++',
        rate: 45,
    },
    
]

const otherSkillInfo = ['TensorFlow','Torch','Keras', 'Jax', 'Git', "Flux"]

const proSkillInfo = ['Strong problem solver','Effective communicator','Team player']

const languageInfo = [{
        name: 'German',
        rate: 5,
        level: 'Native',
    },
    {
        name: 'English',
        rate: 5,
        level: 'Advanced',
    }, 
    {
        name: 'French',
        rate: 3,
        level: 'Intermediate',
    }, 
    {
        name: 'Portuguese',
        rate: 3,
        level: 'Intermediate',
    }, 
]

const interestInfo = [
    {
        name: 'Rock Climbing',
        description: "and hiking in general",
    },
    {
        name: 'Board games',
        description: "especially trivia games",
    },
    // {
    //     name: 'Entrepreneurship Ideas',
    //     description: "",
    // },
    // {
    //     name: 'Smart Home Ideas',
    //     description: "",
    // },
]

const patentsInfo = [
    {"id": "DE102024113229B3",
     "title" : "Procedure for influencing a passenger transport",
     "authors" : "Grunewald, E., Ihme, K., Bosch, E., Walocha, F." 
    }]

export default {
    introInfo: introInfo,
    socialMediaInfo: socialMediaInfo,
    experinceInfo: experinceInfo,
    educationInfo: educationInfo,
    // projectInfo: projectInfo,
    skillInfo: skillInfo,
    // certificateInfo: certificateInfo,
    // volunteerInfo: volunteerInfo,
    languageInfo: languageInfo,
    contactInfo: contactInfo,
    interestInfo: interestInfo,
    summaryInfo: summaryInfo,
    otherSkillInfo: otherSkillInfo,
    proSkillInfo: proSkillInfo,
    publicationInfo: publicationInfo,
    patentsInfo: patentsInfo
}